import { colors } from '@core/theme';
import { PendingAssessmentStatus } from '@shared/models/pending-assessment';
import { PendingAssessmentsRequestFilters } from '@shared/services/assessments';

export const ASSESSMENTS_FIELDS = {
  childId: 'childName',
  clientPrimaryAccountId: 'clientPrimaryAccountId',
  assignedAt: 'assignedAt',
  assessmentId: 'assessmentId',
  clientPrimaryAccountFirstName: 'clientPrimaryAccountFirstName',
  childName: 'childName',
  clientPrimaryAccountLastName: 'clientPrimaryAccountLastName',
  submitted: 'submitted',
  serviceType: 'serviceType',
  country: 'country',
  chronologicalAgeYears: 'chronologicalAgeYears',
  clientPrimaryAccountCreated: 'clientPrimaryAccountCreated',
  degreeOfNeurologicalFunction: 'degreeOfNeurologicalFunction',
  previewAssessment: 'previewAssessment',
  assessmentActions: 'assessmentActions',
};

export enum EVALUATIONS_RATINGS {
  NYA = 'Not yet achieved',
  PA = 'Partially achieved',
  NA = 'Nearly achieved',
  A = 'Achieved',
}

export enum BrainFunctionEvaluationRating {
  NGA = 'NGA',
  NYA = 'NYA',
  PA = 'PA',
  NA = 'NA',
  A = 'A',
}

export const EvaluationRatingValue: Record<BrainFunctionEvaluationRating, number> = {
  [BrainFunctionEvaluationRating.NYA]: 0,
  [BrainFunctionEvaluationRating.NGA]: 0,
  [BrainFunctionEvaluationRating.PA]: 0.5,
  [BrainFunctionEvaluationRating.NA]: 0.75,
  [BrainFunctionEvaluationRating.A]: 1,
};

export enum EVALUATIONS_COMPLETENESS {
  NYA = 'Not yet achieved',
  PA = 'Partially achieved',
  NA = 'Nearly achieved',
  A = 'Achieved',
  PC = 'Partially completed',
  NC = 'Not completed',
}

export const mapEvaluationRatingToData: Record<
  EVALUATIONS_COMPLETENESS,
  { text: string; color: string }
> = {
  [EVALUATIONS_COMPLETENESS.A]: {
    text: 'Achieved',
    color: colors.green,
  },
  [EVALUATIONS_COMPLETENESS.NA]: {
    text: 'Nearly achieved',
    color: colors.blue,
  },
  [EVALUATIONS_COMPLETENESS.PA]: {
    text: 'Partially achieved',
    color: colors.gold,
  },
  [EVALUATIONS_COMPLETENESS.NYA]: {
    text: 'Not yet achieved',
    color: colors.secondaryGreyLight,
  },
  [EVALUATIONS_COMPLETENESS.PC]: { color: colors.inactiveGrey, text: 'Partially completed' },
  [EVALUATIONS_COMPLETENESS.NC]: { color: colors.inactiveGrey, text: 'Not started' },
};

export const ADDITIONAL_CRITERIA_DOMAIN_ID = 'AdditionalCriteria';

export const PendingAssessmentStatusToLabelMap: Record<PendingAssessmentStatus, string> = {
  InProgress: 'In progress',
  UnderReview: 'Under Review',
};

export const PendingAssessmentRequestFilterToLabelMap: Record<
  PendingAssessmentsRequestFilters,
  string
> = {
  ServiceTypes: 'Service Type',
  AssessmentStatuses: 'Status',
  StartDate: 'Start date',
  AssignedClinicians: 'Clinician',
};
